import React from 'react';
import css from './OfferForm.module.css';
import {
  composeValidators,
  moneySubUnitAmountAtLeast,
  required,
} from '../../../../util/validators';
import { Form, PrimaryButton, FieldCurrencyInput, Icons } from '../../../../components';
import appSettings from '../../../../config/settings';
import { Form as FinalForm } from 'react-final-form';
import { types as sdkTypes } from '../../../../util/sdkLoader';
import classNames from 'classnames';
import { formatMoney } from '../../../../util/currency';
import { FormattedMessage } from 'react-intl';
const { Money } = sdkTypes;

const OfferForm = props => {
  const { listingTitle, authorDisplayName } = props;
  return (
    <FinalForm
      {...props}
      render={fieldRenderProps => {
        const {
          rootClassName,
          className,
          handleSubmit,
          inProgress,
          intl,
          invalid,
          values,
          config,
          sendOfferError,
        } = fieldRenderProps;

        const marketplaceCurrency = config.currency;
        const { formatMessage } = intl;
        const classes = classNames(rootClassName || css.root, className);
        const submitInProgress = inProgress;
        const submitDisabled = submitInProgress || invalid;

        const priceRequired = required(intl.formatMessage({ id: 'OfferForm.priceRequired' }));

        const minPrice = new Money(config.listingMinimumPriceSubUnits, config.currency);
        const minPriceRequired = moneySubUnitAmountAtLeast(
          formatMessage({ id: 'OfferForm.priceTooLow' }, { minPrice: formatMoney(intl, minPrice) }),
          config.listingMinimumPriceSubUnits
        );

        const priceValidators = config.listingMinimumPriceSubUnits
          ? composeValidators(priceRequired, minPriceRequired)
          : priceRequired;

        return (
          <Form className={classes} onSubmit={handleSubmit}>
            <Icons name="iconPromote" className={css.icon} />
            <h2 className={css.heading}>
              <FormattedMessage
                id="OfferForm.heading"
                values={{ listingTitle, authorDisplayName }}
              />
            </h2>
            <FieldCurrencyInput
              id="price"
              name="price"
              className={css.input}
              label={formatMessage({ id: 'OfferForm.priceLabel' })}
              placeholder={intl.formatMessage({
                id: 'OfferForm.priceInputPlaceholder',
              })}
              currencyConfig={appSettings.getCurrencyFormatting(marketplaceCurrency)}
              validate={priceValidators}
              autoFocus={true}
            />
            <div className={css.actionBtns}>
              {sendOfferError ? (
                <p className={css.error}>{formatMessage({ id: 'OfferForm.sendEnquiryError' })}</p>
              ) : null}
              <PrimaryButton
                className={css.submitBtn}
                type="submit"
                inProgress={submitInProgress}
                disabled={submitDisabled}
              >
                {formatMessage({ id: 'OfferForm.submitButtonText' })}
              </PrimaryButton>
            </div>
          </Form>
        );
      }}
    />
  );
};

export default OfferForm;
